import InsightsBoardCard from "./cards/InsightsBoardCard";
import FunnelBoardCard from "./cards/FunnelBoardCard";
import FlowBoardCard from "./cards/FlowBoardCard";
import RetentionBoardCard from "./cards/RetentionBoardCard";
import CustomChartBoardCard from "./cards/CustomChartBoardCard";
import TextBoardCard from "./cards/TextBoardCard";
import MediaBoardCard from "./cards/MediaBoardCard";
import QuickLinksBoardCard from "./cards/QuickLinksBoardCard";
import TeamWidgetBoardCard from "./cards/TeamWidgetBoardCard";
/**
 * Central registry: cardType → { Component, defaults, canEdit }
 *
 * Component receives:
 *   card, result, onEdit?, onDelete?, onSaveContent?, onSaveUrl?,
 *   onSaveDisplayOptions?, boardId?, homeWorkspaceId?, readOnly
 */
export const CARD_REGISTRY = {
  insights:     { Component: InsightsBoardCard,    canEdit: true  },
  funnel:       { Component: FunnelBoardCard,      canEdit: true  },
  flow:         { Component: FlowBoardCard,        canEdit: true  },
  retention:    { Component: RetentionBoardCard,   canEdit: true  },
  custom_chart: { Component: CustomChartBoardCard, canEdit: false },
  text:         { Component: TextBoardCard,        canEdit: true  },
  media:        { Component: MediaBoardCard,       canEdit: false },
  quick_links:  { Component: QuickLinksBoardCard,  canEdit: false },
  team_widget:  { Component: TeamWidgetBoardCard,  canEdit: false },
};

/** Resolve component for a card type; falls back to InsightsBoardCard. */
export function getCardComponent(cardType) {
  const key = (cardType || "insights").toLowerCase();
  return CARD_REGISTRY[key] ?? CARD_REGISTRY.insights;
}

/** Card types that get the bordered shell treatment (all analytics types). */
export const BORDERED_CARD_TYPES = new Set([
  "insights", "funnel", "flow", "retention", "custom_chart",
  "quick_links", "team_widget",
]);

/** Card types whose editors live in the studio editor pages. */
export const EDITOR_CARD_TYPES = new Set(["insights", "funnel", "flow", "retention", "text", "media"]);
